import React, { useEffect } from 'react'

const Alert = ({ msg, type, removeAlert, list }) => {
  useEffect(() => {
    const timeOut = setTimeout(() => {
      removeAlert()
    }, 2000)
    return () => clearTimeout(timeOut)
  }, [list, removeAlert])
  return <p className={`alert alert-${type}`}> {msg} </p>
}

export default Alert
